import { Instance, types } from 'mobx-state-tree';
import { ChatEmployeeDTO } from 'http-requests/house-chats';
import { RequestStateModel } from '../../general-models';

export const ChatEmployeeModel = types
  .model('ChatEmployeeModel', {
    id: types.string,
    number: types.optional(types.string, ''),
    first_name: types.optional(types.maybeNull(types.string), null),
    last_name: types.optional(types.maybeNull(types.string), null),
    patronymic_name: types.optional(types.maybeNull(types.string), null),
    position: types.optional(types.maybeNull(types.string), null),
    department: types.optional(types.maybeNull(types.string), null),
    email: types.optional(types.maybeNull(types.string), null),
  })
  .views((self) => ({
    get fullName(): string {
      const name = [self.last_name, self.first_name, self.patronymic_name]
        .filter(Boolean)
        .join(' ')
        .trim();

      return name || 'Без имени';
    },
  }));

export const ChatEmployeesModel = types
  .model('ChatEmployeesModel', {
    items: types.optional(types.array(ChatEmployeeModel), []),
    requestState: types.optional(RequestStateModel, {}),
  })
  .actions((self) => ({
    setItems(items: ChatEmployeeDTO[]) {
      self.items.replace(
        items.map((item) => ({
          id: item.id,
          number: item.number,
          first_name: item.first_name,
          last_name: item.last_name,
          patronymic_name: item.patronymic_name,
          position: item.position,
          department: item.department,
          email: item.email,
        })) as unknown as Instance<typeof ChatEmployeeModel>[]
      );
    },
  }));

export type TChatEmployee = Instance<typeof ChatEmployeeModel>;
export type TChatEmployees = Instance<typeof ChatEmployeesModel>;
